import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import commonEN from './locales/en/footer.json';
import accueilEN from './locales/en/accueil.json';
import contactEN from './locales/en/contact.json';
import produitEN from './locales/en/product.json';
import aboutEN from './locales/en/about.json';
import HowItWorksEN from './locales/en/howItWorks.json';
import OfferEN from './locales/en/offre.json';
import securityContentEN from './locales/en/securityContent.json';
import lifeSchoolEN from './locales/en/lifeSchool.json';
import lifeCompaniesEN from './locales/en/lifeCompanies.json';
import lifeIndividualsEN from './locales/en/lifeIndividuals.json';
import lifeIntelligenceEN from './locales/en/lifeIntelligence.json';

import commonFR from './locales/fr/footer.json';
import accueilFR from './locales/fr/accueil.json';
import contactFR from './locales/fr/contact.json';
import produitFR from './locales/fr/product.json';
import aboutFR from './locales/fr/about.json'
import HowItWorksFr from './locales/fr/howItWorks.json'
import OfferFR from './locales/fr/offre.json'
import securityContentFR from './locales/fr/securityContent.json';
import lifeSchoolFR from './locales/fr/lifeSchool.json';
import lifeCompaniesFR from './locales/fr/lifeCompanies.json';
import lifeIndividualsFR from './locales/fr/lifeIndividuals.json';
import lifeIntelligenceFR from './locales/fr/lifeIntelligence.json';

import commonDE from './locales/de/footer.json';
import accueilDE from './locales/de/accueil.json';
import contactDE from './locales/de/contact.json';
import produitDE from './locales/de/product.json'
import aboutDE from './locales/de/about.json'
import HowItWorksDE from './locales/de/howItWorks.json'
import OfferDE from './locales/de/offre.json'
import securityContentDE from './locales/de/securityContent.json';
import lifeSchoolDE from './locales/de/lifeSchool.json';
import lifeCompaniesDE from './locales/de/lifeCompanies.json';
import lifeIndividualsDE from './locales/de/lifeIndividuals.json';
import lifeIntelligenceDE from './locales/de/lifeIntelligence.json';

import commonIT from './locales/it/footer.json';
import accueilIT from './locales/it/accueil.json';
import contactIT from './locales/it/contact.json';
import produitIT from './locales/it/product.json'
import aboutIT from './locales/it/about.json'
import HowItWorksIT from './locales/it/howItWorks.json'
import OfferIT from './locales/it/offre.json'
import securityContentIT from './locales/it/securityContent.json';
import lifeSchoolIT from './locales/it/lifeSchool.json';
import lifeCompaniesIT from './locales/it/lifeCompanies.json';
import lifeIndividualsIT from './locales/it/lifeIndividuals.json';
import lifeIntelligenceIT from './locales/it/lifeIntelligence.json';
import lifeIntelligenceES from './locales/es/lifeIntelligence.json';
import lifeIntelligenceAR from './locales/ar/lifeIntelligence.json';
import lifeIntelligenceZH from './locales/zh/lifeIntelligence.json';
import lifeIntelligenceJA from './locales/ja/lifeIntelligence.json';

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      fr: { 
        common: commonFR,
        header: { header: { login: 'Se connecter' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Idées, nouveautés produit, vision.' },
          post: { notFound: 'Article introuvable', back: 'Retour' }
        },
        accueil: accueilFR,
        contact: contactFR,
        product: produitFR,
        about : aboutFR,
        howItWorks : HowItWorksFr,
        offre : OfferFR,
        securityPage : securityContentFR,
        lifeSchoolsPage : lifeSchoolFR,
        lifeCompaniesPage : lifeCompaniesFR,
        lifeIndividualsPage : lifeIndividualsFR
        ,lifeIntelligence: lifeIntelligenceFR
      },
      en: {
        common: commonEN,
        header: { header: { login: 'Log in' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Ideas, product updates, vision.' },
          post: { notFound: 'Post not found', back: 'Back' }
        },
        accueil: accueilEN,
        contact: contactEN,
        product: produitEN,
        about : aboutEN,
        howItWorks : HowItWorksEN,
        offre : OfferEN,
        securityPage : securityContentEN,
        lifeSchoolsPage : lifeSchoolEN,
        lifeCompaniesPage : lifeCompaniesEN,
        lifeIndividualsPage : lifeIndividualsEN
        ,lifeIntelligence: lifeIntelligenceEN
      },
      de: { 
        common: commonDE,
        header: { header: { login: 'Anmelden' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Ideen, Produktupdates, Vision.' },
          post: { notFound: 'Artikel nicht gefunden', back: 'Zurück' }
        },
        accueil: accueilDE,
        contact: contactDE,
        product: produitDE,
        about : aboutDE,
        howItWorks : HowItWorksDE,
        offre : OfferDE,
        securityPage : securityContentDE,
        lifeSchoolsPage : lifeSchoolDE,
        lifeCompaniesPage : lifeCompaniesDE,
        lifeIndividualsPage : lifeIndividualsDE
        ,lifeIntelligence: lifeIntelligenceDE
      },
      it: { 
        common: commonIT,
        header: { header: { login: 'Accedi' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Idee, aggiornamenti prodotto, visione.' },
          post: { notFound: 'Articolo non trovato', back: 'Indietro' }
        },
        accueil: accueilIT,
        contact: contactIT,
        product: produitIT,
        about : aboutIT,
        howItWorks: HowItWorksIT,
        offre : OfferIT,
        securityPage : securityContentIT,
        lifeSchoolsPage : lifeSchoolIT,
        lifeCompaniesPage : lifeCompaniesIT,
        lifeIndividualsPage : lifeIndividualsIT
        ,lifeIntelligence: lifeIntelligenceIT
      },
      'fr-CH': {
        common: commonFR,
        header: { header: { login: 'Se connecter' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Idées, nouveautés produit, vision.' },
          post: { notFound: 'Article introuvable', back: 'Retour' }
        },
        accueil: accueilFR,
        contact: contactFR,
        product: produitFR,
        about : aboutFR,
        howItWorks: HowItWorksFr,
        offre : OfferFR,
        securityPage : securityContentFR,
        lifeSchoolsPage : lifeSchoolFR,
        lifeCompaniesPage : lifeCompaniesFR,
        lifeIndividualsPage : lifeIndividualsFR
        ,lifeIntelligence: lifeIntelligenceFR
      },
      'de-CH': { 
        common: commonDE,
        header: { header: { login: 'Anmelden' } },
        blog: {
          list: { title: 'Blog', subtitle: 'Ideen, Produktupdates, Vision.' },
          post: { notFound: 'Artikel nicht gefunden', back: 'Zurück' }
        },
        accueil: accueilDE,
        contact: contactDE,
        product: produitDE,
        about : aboutDE,
        howItWorks: HowItWorksDE,
        offre : OfferDE,
        securityPage : securityContentDE,
        lifeSchoolsPage : lifeSchoolDE,
        lifeCompaniesPage : lifeCompaniesDE,
        lifeIndividualsPage : lifeIndividualsDE
        ,lifeIntelligence: lifeIntelligenceDE
      },
      es: { lifeIntelligence: lifeIntelligenceES },
      ar: { lifeIntelligence: lifeIntelligenceAR },
      zh: { lifeIntelligence: lifeIntelligenceZH },
      ja: { lifeIntelligence: lifeIntelligenceJA },
    },
    lng: 'fr', // Langue par défaut
    fallbackLng: 'en', // Langue de repli
    interpolation: {
      escapeValue: false, // React déjà fait l'échappement
    },
    react: {
      useSuspense: true, // Utilise le suspense pour le chargement des traductions
    },
  });

export default i18n;
